import { render, staticRenderFns } from "./DashOptionToggleCard.vue?vue&type=template&id=5523b56e&"
import script from "./DashOptionToggleCard.vue?vue&type=script&lang=js&"
export * from "./DashOptionToggleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports